export default __webpack_public_path__ + "static/media/idea.2254459e.png";